import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useGetVideoQuery } from "../../redux/features/videos/videosAPI";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import EditVideoForm from "../../components/EditVideoForm";
import usePageTitle from "../../utils/usePageTitle";

export default function EditVideo() {
  usePageTitle("Edit Video");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const { videoId } = useParams();
  const { data: video, isLoading, isError, error } = useGetVideoQuery(videoId);

  let content = null;

  if (isLoading) {
    content = <div className="text-center mt-6">Loading...</div>;
  }
  if (!isLoading && isError) {
    content = <div className="text-center mt-6">{error}</div>;
  }
  if (!isLoading && !isError && video?.id) {
    content = <EditVideoForm video={video} />;
  }

  return (
    <div
      style={{
        minWidth: "50%",
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
      className="container relative"
    >
      <h2 className="text-center text-3xl font-bold text-cyan">Edit Video</h2>
      <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
        {content}
      </div>
    </div>
  );
}
